<template>
  <div>
    this is only a placeholder for the plans list page
  </div>
</template>
